import React from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppConfig from "./config/app.config";
import { AuthProvider } from "./context/AuthContext";
import store from "./redux/store";
import Routes from "./Routes";

const App = () => {
  // eslint-disable-next-line no-console
  console.info(`e-FIS: v.${AppConfig.clientVersion} (${AppConfig.env})`, `Release: ${AppConfig.clientRelease}`);

  return (
    <Provider store={store}>
      <AuthProvider>
        <ToastContainer />
        <Routes />
      </AuthProvider>
    </Provider>
  );
};

export default App;
